"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var general_1 = require("utils/general");
var AutocompleteButton = (0, material_1.styled)(TextButton_1.default, { shouldForwardProp: (0, general_1.omitProps)('isPlaceholder') })(function (_a) {
    var _b;
    var theme = _a.theme, isPlaceholder = _a.isPlaceholder;
    return ({
        '&.MuiButton-textNeutral': { color: isPlaceholder ? (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main : theme.palette.riverstone },
        padding: theme.spacing(0.5, 1.5),
        height: theme.spacing(4),
        letterSpacing: theme.typography.body1.letterSpacing,
        justifyContent: 'flex-start',
        '&.highlightInput': { borderColor: theme.palette.primary.light },
        ':disabled': { opacity: 0.5 },
        ':hover': {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.grey[600],
        },
        '& .MuiButton-endIcon > *:nth-of-type(1)': { fontSize: theme.typography.body2.fontSize }, // should this be applied to buttonStyles too?
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(AutocompleteButton, {
    color: 'neutral',
    outlined: true,
    fullWidth: true,
});
